import "./css/loadingBox.css";

export default function LoadingBox({ text }) {
  const textLoading = text || "Đang tải...";
  return (
    <div className="loading-box">
      <div className="load-animations d-flex ">
        <div className="load-9 mx-3">
          <div className="spinner">
            <div className="bubble-1"></div>
            <div className="bubble-2"></div>
          </div>
        </div>

        <div className="letter-holder">
          {textLoading.split("").map((char, index) => (
            <span
              key={index}
              className="letter"
              style={{
                animationDelay: `${0.48 + index * 0.12}s`,
                whiteSpace: "pre",
              }}
            >
              {char === " " ? "\u00A0" : char}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
